import { createMap, geoQueryResultToArray } from './map';
import { getOpenModalFunction } from './modal';

import pipe from 'lodash/fp/pipe';
import partialRight from 'lodash/fp/partialRight';

const toNumber = value => +value;
const getFromEvent = (event, prop) => event.get(prop);
const getObjectId = partialRight(getFromEvent, ['objectId']);

function createFeature(item) {
	return {
		type: 'Feature',
		id: item.ID,
		geometry: {
			type: 'Point',
			coordinates: item.COORDINATES.split(',').map(toNumber),
		},
		properties: {
			hintContent: item.NAME,
			...item
		},
	};
}

window.addEventListener('DOMContentLoaded', () => {
	const mapContainer = document.getElementById('points-map');
	if (!mapContainer)
		return;

	const mapContainerButton = document.getElementById('points-map-button');
	const mapContainerButtonOpen = mapContainerButton.querySelector('.card-home-map-button__open');
	const mapContainerButtonClose = mapContainerButton.querySelector('.card-home-map-button__close');

	let finalMap;

	const request = {
		items: mapContainer.dataset.mapData,
		item: mapContainer.dataset.mapItemPath,
	}

	mapContainerButton.addEventListener('click', () => {
		if (!request.items || !request.item)
			return false;

		async function onDone(config) {

			if (!finalMap) {

				await ymaps.ready();

				const openModal = await getOpenModalFunction(request);

				const openObjectModalById = pipe(
					getObjectId,
					openModal,
				);

				const MyIconContentLayout = ymaps.templateLayoutFactory.createClass('<div class="ymaps-cluster">{{ properties.geoObjects.length }}</div>');

				const state = {
					center: [55.751574, 37.573856],
					zoom: 9,
					// center: config.center.map(toNumber),
					// zoom: toNumber(config.zoom),
					controls: [],
				}

				const options = {
					geoObjectIconLayout: 'default#image',
					geoObjectIconImageHref: '/local/assets/svg/map-object.svg',
					geoObjectIconImageSize: [50, 50],
					geoObjectIconImageOffset: [-25, -50],
					geoObjectClusterIconContentLayout: MyIconContentLayout,
					geoObjectClusterIcons: [{
						href: '/local/assets/svg/map-cluster.svg',
						size: [48, 48],
						offset: [-24, -24],
						shape: {
							type: 'Circle',
							coordinates: [0, 0],
							radius: 24,
						},
					},],
				}

				finalMap = await createMap(mapContainer, state, options);

				const { map, objectManager } = finalMap;
				const geoObjects = config.data.data.items.map(createFeature);
				const geoObjectsFilter = geoObjects.filter(item => item.geometry.coordinates.length === 2);

				objectManager.add(geoObjectsFilter);
				objectManager.objects.events.add('click', openObjectModalById);
			}
			else {
				finalMap.map.destroy();
				finalMap = null;
			}
		}

		const axios = require('axios');

		axios.get(request.items)
			.then(async function (response) {
				await onDone(response);

				mapContainer.addEventListener('transitionend', () => {
					if (!finalMap) return
					finalMap.map.container.fitToViewport();
				}, { once: true })

				mapContainer.classList.toggle('active');
				mapContainerButtonOpen.classList.toggle('active');
				mapContainerButtonClose.classList.toggle('active');

			})
			.catch(function (error) {
				console.log(error);
			});
	})
});
